module.exports = new __parcel__URL__("machines_sunday_skirmish_trophy2.1ed2159f.png").toString();